//Actions
import {
  SET_ADMIN_BATCHES_DATA,
  SET_ADMIN_BATCHES_FILTERS_LABELS,
  SET_ADMIN_BATCHES_FILTERS,
  SET_ADMIN_BATCHES_LOADER,
  CLEAR_ADMIN_BATCHES_FILTERS,
  PATCH_ADMIN_BATCH_PROGRESS,
  PATCH_ADMIN_BATCH_STATUSES,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  batches: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalBatchesInDB: null,
  filterslabels: [],
  loading: false,
  applyFilters: false,
  filterSize: null,
  totalRevenue: 0,
  totalQuantity: 0,
  filters: {},
};

const adminBatchesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ADMIN_BATCHES_DATA:
      return {
        ...state,
        batches: payload.rows,
        rowsCount: payload.count,
        totalBatchesInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        totalRevenue: payload.totalRevenue,
        totalQuantity: payload.totalQuantity,
      };
    case PATCH_ADMIN_BATCH_PROGRESS: {
      // The API sends batch ids as strings (BIGINT) in the list and as numbers in progress events
      const index = state.batches.findIndex((batch) => Number(batch.batchId) === Number(payload?.batchId));
      if (index === -1) return state;

      // A list fetch and a socket push can arrive out of order; never replace newer progress with older
      const current = state.batches[index].progress;
      if (current?.updatedAt && payload.updatedAt && current.updatedAt > payload.updatedAt) {
        return state;
      }

      const batches = [...state.batches];
      batches[index] = { ...batches[index], progress: payload };
      return { ...state, batches };
    }
    case PATCH_ADMIN_BATCH_STATUSES: {
      let changed = false;
      const batches = state.batches.map((batch) => {
        // Ids are strings in the list and numbers in the event
        const change = (payload || []).find((item) => Number(item?.batchId) === Number(batch.batchId));
        if (!change) return batch;

        const batchStatus = change.status ?? batch.batchStatus;
        const pipelineState = change.state ?? batch.pipelineState;
        if (batchStatus === batch.batchStatus && pipelineState === batch.pipelineState) return batch;

        changed = true;
        return { ...batch, batchStatus, pipelineState };
      });

      return changed ? { ...state, batches } : state;
    }
    case SET_ADMIN_BATCHES_LOADER:
      return { ...state, loading: payload };
    case SET_ADMIN_BATCHES_FILTERS_LABELS:
      return { ...state, filterslabels: payload };
    case SET_ADMIN_BATCHES_FILTERS:
      return {
        ...state,
        applyFilters: payload.applyFilters,
        filterSize: payload.filterSize,
        filters: payload.filters,
      };
    case CLEAR_ADMIN_BATCHES_FILTERS:
      return { ...state, applyFilters: false, filterSize: null, filters: {} };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { adminBatchesReducers };
